import React from 'react';
import MainContent from '../components/MainContent';

const Home = () => {
  return (
    <div className="home-page">
      <MainContent />
    </div>
  );
};

export default Home;
